import { CircularProgress } from '@material-ui/core';
import React, { createElement, useState } from 'react';
import Frame, { FrameContextConsumer } from 'react-frame-component';
import config from '../../../config/config';
import { getWidgetToken } from '../../../lib/widgetTokenService';
import { getLanguage } from '../../../providers/LanguageProvider';

const language = getLanguage();
const dataBrowserWidget = 'opower-widget-data-browser';
const useFixtures = process.env.NODE_ENV === 'development';
const googleTagManagerHeadScriptName = 'GOOGLE_CLOUD_TAG_MANAGER_HEAD_SCRIPT';
const opowerScriptUrl =
  // TODO why is gatsby trying to SSR this STAHP (╯°□°）╯︵ ┻━┻
  typeof window !== 'undefined' &&
  (window.location.host === 'new.portlandgeneral.com' ||
    window.location.host === 'portlandgeneral.com')
    ? `https://pgn.opower.com/ei/x/embedded-api/core.js?auth-mode=oauth&locale=${language}_US`
    : `https://ei-pgn-stage.opower.com/ei/x/embedded-api/core.js?auth-mode=oauth&locale=${language}_US${
        useFixtures ||
        (typeof window !== 'undefined' &&
          (window.location.host === 'dev.portlandgeneral.com' ||
            window.location.host === 'gcp-csweb-dev-d78c.web.app'))
          ? '&fixtures=true'
          : ''
      }`;

const googleTagManagerHeadCode = `(function(w,d,s,l,i){w[l] = w[l] || []{'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${config.googleTagManager.oPowerWidgetCode}');`;

/**
 * Creates an iframe component containing an opower widget
 * Creating opower widgets in an iframe prevent opower widgets from polluting
 * our page and facilitate refreshing data without a full page reload
 */
export function createOpowerWidget(widgetName: string, type = 'RES') {
  return ({
    entityId,
    ...props
  }: {
    entityId: string | null | undefined;
    props?: any[];
  }) => {
    const [height, setHeight] = useState(200);
    const [loading, setLoading] = useState(!useFixtures);

    const handleUnauthorized = async (event: Event) => {
      event.preventDefault();
      const {
        detail: { authorize },
      } = event as any;
      try {
        const tokens = await getWidgetToken();
        const authorization = {
          accessToken: tokens.accessToken?.token,
        };
        authorize(null, authorization); // Do not call if user is logged out
      } catch (e) {
        authorize(e);
      }
    };

    const handleStart = (event: Event) => {
      event.preventDefault();
      const {
        detail: { start, setEntityIds },
      } = event as any;
      setEntityIds([entityId]);
      start();
      setLoading(false);
    };

    const handleIframeResize = (newHeight: number) => {
      setHeight(newHeight + 20);
    };

    if (!entityId && loading) {
      return <CircularProgress />;
    }

    // TODO why is gatsby trying to SSR this STAHP (╯°□°）╯︵ ┻━┻
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return null;
    }

    return (
      <Frame style={{ width: '100%', height, border: 0, overflow: 'hidden' }}>
        <FrameContextConsumer>
          {({ document, window }) => {
            const scriptInjected = document.querySelector(
              `script[src="${opowerScriptUrl}"]`,
            );
            const foundGoogleTagManagerHeadScript = document.querySelector(
              `script[data-name="${googleTagManagerHeadScriptName}"]`,
            );

            if (!foundGoogleTagManagerHeadScript) {
              const script = document.createElement('script');
              script.setAttribute('data-name', googleTagManagerHeadScriptName);
              document.head.appendChild(script);
              const tagManager = document.querySelector(
                `script[data-name="${googleTagManagerHeadScriptName}"]`,
              );
              if (tagManager) {
                tagManager.innerHTML = googleTagManagerHeadCode;
              }
            }

            if (!scriptInjected) {
              const script = document.createElement('script');
              script.src = opowerScriptUrl;
              script.async = true;
              document.body.appendChild(script);
              window.addEventListener(
                'opower:unauthorized',
                handleUnauthorized,
              );
              window.addEventListener('opower:start', handleStart);
              //Resize Iframe
              window.setInterval(() => {
                handleIframeResize(document.body.offsetHeight);
              }, 500);
            }

            if (widgetName === dataBrowserWidget) {
              return React.createElement(
                'div',
                {},
                createElement(widgetName, props),
                createElement('opower-widget-usage-export'),
              );
            }
            return createElement(widgetName, props);
          }}
        </FrameContextConsumer>
      </Frame>
    );
  };
}
